import { combineReducers } from 'redux'
import { createLoadingDataReducer } from '../../../helpers/redux'
import { IAction } from '../../apiMiddleware'
import type { IAgentMemory, IAgentMemoryListData } from '../memories/reducer'
import * as actions from './actions'

// Prompts are AgentMemory rows with type='prompt' — same shape as memories.
export type IAgentPrompt = IAgentMemory
export type IAgentPromptListData = IAgentMemoryListData

export default combineReducers({
  list: createLoadingDataReducer<IAgentPromptListData>(
    [actions.LIST_PROMPTS_REQUEST],
    [actions.ADD_PROMPT_REQUEST, actions.UPDATE_PROMPT_REQUEST, actions.DELETE_PROMPT_REQUEST],
    // withSaveActionLiveEdit — removes deleted rows from the list in place
    // and patches updated rows without waiting for a full refetch.
    true,
  ),

  selected(state: IAgentPrompt | null = null, action: IAction<IAgentPrompt>): IAgentPrompt | null {
    switch (action.type) {
      case actions.GET_PROMPT_SUCCESS:
        return action.data
      case actions.UPDATE_PROMPT_SUCCESS:
        if (state && action.data?.id === state.id) return action.data
        return state
      case actions.CLEAR_SELECTED_PROMPT:
      case actions.DELETE_PROMPT_SUCCESS:
        return null
      default:
        return state
    }
  },
})
